var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 980.000000 988.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,988.000000) scale(0.100000,-0.100000)",
    fill: "#aaa",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4665 9869 c-943 -71 -1805 -576 -2336 -1372 -267 -401 -436 -861 -494 -1352 -20 -165 -23 -508 -6 -665 107 -974 640 -1817 1471 -2326 l99 -61 -146 -53 c-468 -167 -919 -408 -1308 -700 -981 -736 -1654 -1802 -1889 -2995 -21 -106 -56 -319 -56 -340 0 -3 140 -4 312 -3 l311 3 18 108 c282 1672 1537 3033 3188 3458 786 202 1645 174 2418 -80 398 -130 825 -347 1163 -589 930 -666 1561 -1673 1749 -2789 l18 -108 312 -3 313 -2 -7 42 c-102 671 -283 1215 -581 1745 -326 581 -769 1095 -1299 1508 -129 101 -405 286 -557 374 -242 139 -584 294 -866 391 l-92 33 100 61 c802 491 1330 1299 1460 2232 5 39 14 150 20 247 42 748 -199 1496 -675 2092 -106 133 -345 372 -475 475 -619 491 -1384 727 -2165 669z m595 -634 c987 -150 1786 -871 2030 -1830 58 -230 74 -356 74 -605 0 -126 -5 -254 -13 -310 -66 -476 -242 -889 -532 -1250 -98 -122 -308 -325 -431 -418 -750 -564 -1741 -656 -2584 -241 -227 112 -430 257 -623 444 -409 398 -651 882 -732 1465 -20 142 -17 496 5 645 136 908 736 1652 1587 1971 198 74 390 117 659 148 79 9 460 -3 560 -19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.053113180df9c824b49e6851cd8ab8b9.svg";
export { ForwardRef as ReactComponent };